import './bootstrap'
import './bugsnag'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { createInertiaApp } from '@inertiajs/vue2'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'

Vue.use(VueI18n)

let i18n
if (window.locale && window.localeMessages) {
  i18n = new VueI18n({
    locale: window.locale,
    fallbackLocale: window.locale,
    messages: {
      [window.locale]: window.localeMessages,
    },
    numberFormats: {
      [window.locale]: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
    },
  })
}

const appName = import.meta.env.VITE_APP_NAME || 'Contratación aló'

createInertiaApp({
  title: (title) => (title ? `${title} - ${appName}` : appName),
  resolve: (name) => resolvePageComponent(`./${name}.vue`, import.meta.glob('./**/Pages/**/*.vue')),
  setup({ el, App, props, plugin }) {
    Vue.use(plugin)
    Vue.prototype.$route = window.route

    new Vue({
      render: (h) => h(App, props),
      i18n,
    }).$mount(el)
  },
  progress: { color: '#4B5563' },
})
